import { Injectable } from '@angular/core';
import { AuthService } from './shared/modules/auth/auth.service';

@Injectable()
export class AppInitializer {
  constructor(private authService: AuthService) {}

  public load(): Promise<boolean> {
    return this.authService.checkAuth();
  }
}
